module.exports = __webpack_public_path__ + "img/bike-ride-4-min.8afcfffe.png";